import ShoppingBasketIconPath from "@ingka/ssr-icon/paths/shopping-basket";

export default ShoppingBasketIconPath;
